import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout/Layout';

const LogoutPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: 'Logout',
        className: 'logout',
    };

    useEffect(() => {
        async function handleLogout() {
            await actions.userActions.logout();
        }

        if (user.loggedIn) {
            handleLogout();
        }
    }, [user.loggedIn]);

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className={page?.className}>
                <div className='alert-success text-center notification' role='alert'>
                    You&apos;ve been successfully logged out!
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);
